import { render, staticRenderFns } from "./ed-homeworks-course-container.vue?vue&type=template&id=a5a4bf0c&scoped=true&"
import script from "./ed-homeworks-course-container.ts?vue&type=script&lang=ts&"
export * from "./ed-homeworks-course-container.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homeworks-course-container.scss?vue&type=style&index=0&id=a5a4bf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a4bf0c",
  null
  
)

export default component.exports